import backlog from './utils/backlog'
import columns from './utils/columns'

const state = () => ({
  backlog,
  columns,
  links: {},
})

export default state
